import $ from 'jquery'
import IMask from 'imask'

$(function() {
  const input = document.getElementById('user_activation_phoneNumber')
  if (input) {
    new IMask(input, { mask: /^[+]?[\-\(\)\d]*$/ })
  }
})